import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import {
  Home, Case, About, Company, Contact, ContactSuccess,
  Pay, PayComplete, Error404,
} from 'pages';

const Routes: React.FC = _ => {
  return (
    <div className="router-wrapper">
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/case" component={Case} />
        <Route path="/about" component={About} />
        <Route path="/company" component={Company} />
        <Route path="/contact/success" component={ContactSuccess} />
        <Route path="/contact" component={Contact} />
        <Route path="/ceo/contact" component={() => <Redirect to='/contact' />} />
        <Route path="/pay/:uid/complete" component={PayComplete} />
        <Route path="/pay/:uid" component={Pay} />
        <Route component={Error404} />
      </Switch>
    </div>
  );
};

export default Routes;
